export function normalize(str) {
    return str.toLowerCase().trim();
};

/**
 * Récupère une valeur sécurisée à partir d'un objet, en tenant compte des différences de formatage des clés.
 *
 * @param {Object} obj - L'objet dans lequel rechercher la clé.
 * @param {string} key - La clé cible à rechercher dans l'objet.
 * @param {string} defaultKey - La clé par défaut à utiliser si la clé cible n'est pas trouvée.
 * @returns {*} - La valeur associée à la clé trouvée ou à la clé par défaut si aucune correspondance n'est trouvée.
 *
 * @example
 * const obj = { 'Key-One': 42, 'defaultKey': 'Fallback' };
 * const value = getSafeValue(obj, 'key-one', 'defaultKey'); // Retourne 42
 * const fallback = getSafeValue(obj, 'nonExistentKey', 'defaultKey'); // Retourne 'Fallback'
 */
export function getSafeValue(obj, key, defaultKey) {
    const normalizedKey = normalize(key);
    const matchingKey = Object.keys(obj).find(k => normalize(k) === normalizedKey);
    return obj[matchingKey] || obj[defaultKey];
};

/**
 * Récupère une valeur imbriquée dans un objet en suivant un chemin donné.
 *
 * @param {Object} obj - L'objet dans lequel chercher la valeur.
 * @param {string} path - Le chemin vers la valeur imbriquée, sous forme de chaîne de caractères séparée par des points.
 * @returns {*} - La valeur trouvée à l'emplacement spécifié, ou `undefined` si le chemin n'existe pas.
 *
 * @example
 * const data = { user: { profile: { name: 'Alice' } } };
 * const name = getNestedValue(data, 'user.profile.name'); // Retourne 'Alice'
 * const missing = getNestedValue(data, 'user.profile.age'); // Retourne undefined
 *
 * @note
 * Cette fonction utilise `reduce` pour parcourir l'objet à chaque niveau en suivant les clés du chemin.
 * Si une clé n'existe pas à un niveau donné, la fonction retourne immédiatement `undefined` sans provoquer d'erreur.
 */
export function getNestedValue(obj, path) {
    return path.split('.').reduce((acc, key) => acc && acc[key], obj);
};

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
};
